export default "<span>{{hours}}:{{minutes}}:{{seconds}}</span>";